import React, { useMemo } from 'react'

const ITEMS_TO_DISPLAY_COLLAPSED = 4

const NativeReviewsList = ({ items, title, Icon, isCollapsed, iconColor }) => {
  const itemsToDisplay = useMemo(() => {
    return isCollapsed ? items.slice(0, ITEMS_TO_DISPLAY_COLLAPSED) : items
  }, [isCollapsed, items])

  return (
    <div className="list-container">
      <p className="mb-2 text-base text-gray-1100">{title}</p>
      <ul className="flex flex-col flex-wrap gap-2 text-sm">
        {itemsToDisplay.map((item) => (
          <li
            className="flex items-center"
            key={item.title}
          >
            {Icon && (
              <div className={`mr-2.5 ${iconColor}`}>
                <Icon />
              </div>
            )}
            {`${item.title} (${item.count})`}
          </li>
        ))}
      </ul>
    </div>
  )
}

export default NativeReviewsList
